import api from './api';

export const getFabricCoatings = async () => {
  const { data } = await api.get('/fabric-coatings');
  return data;
};

export const createFabricCoating = async (name, image_url, description) => {
  const { data } = await api.post('/fabric-coatings', { name, image_url, description });
  return data;
};

export const updateFabricCoating = async (id, params) => {
  const { data } = await api.put(`/fabric-coatings/${id}`, params);
  return data;
};

export const deleteFabricCoating = async (id) => {
  const { data } = await api.delete(`/fabric-coatings/${id}`);
  return data;
};
